var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "formTitle",
      style: {
        "text-align": _vm.textAlign || "center",
      },
    },
    [
      _c(
        "span",
        {
          style: {
            "font-weight": _vm.fontWeight || 700,
            "font-size": (_vm.fontSize || 32) + "px",
            color: _vm.fontColor || "#000",
          },
        },
        [_vm._v(_vm._s(_vm.value))]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }